import type {CustomLabel} from '@cohort/shared-frontend/common/React';
import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import Color from 'color';

interface CheckboxProps {
  checked: boolean;
  setChecked: (checled: boolean) => void;
  testId: string;
}

export const Checkbox: CustomLabel<CheckboxProps> = ({checked, setChecked, testId}) => {
  const {hasDarkBg, accentColor} = useThemeContext();

  return (
    <input
      data-testid={testId}
      id={`${testId}-${Checkbox.name}`}
      name={`${testId} ${Checkbox.name}`}
      title={`${testId} ${Checkbox.name}`}
      type="checkbox"
      checked={checked}
      onChange={() => setChecked(!checked)}
      className={classNames(
        'h-4 w-4 cursor-pointer rounded border focus:outline-none focus:ring-0 focus:ring-offset-0',
        hasDarkBg ? 'border-white/30' : 'border-black/30'
      )}
      style={{
        color:
          Color(accentColor).luminosity() > 0.8
            ? String(Color(accentColor).darken(0.5))
            : accentColor,
      }}
    />
  );
};
